import type { WeeztixHealthResponse } from '../interfaces/weeztix'
import { ApiClient } from './axiosClient'

/**
 * Base URL path for Weeztix API endpoints
 */
const WEEZTIX_BASE_PATH = '/weeztix'

/**
 * API service for Weeztix OAuth authentication
 */
export const weeztixAPI = {
  /**
   * Check the health and authentication status of Weeztix OAuth
   * @returns Promise with health status data
   * @throws Error if request fails
   */
  checkHealth: async (): Promise<WeeztixHealthResponse> => {
    const response = await ApiClient.get<WeeztixHealthResponse>(
      `${WEEZTIX_BASE_PATH}/health`
    )
    return response.data
  },

  /**
   * Get the OAuth login URL from the backend
   * @returns Promise with the authorization URL
   */
  getLoginUrl: async (): Promise<string> => {
    const response = await ApiClient.get<{ url: string }>(
      `${WEEZTIX_BASE_PATH}/login`
    )
    return response.data.url
  },

  /**
   * Initiate the OAuth login flow by opening the authorization URL
   * This will open the Weeztix OAuth page in a new window
   */
  initiateLogin: async (): Promise<void> => {
    const url = await weeztixAPI.getLoginUrl()
    window.open(url, '_blank')
  },

  /**
   * Get the full URL for Weeztix endpoints
   * @returns The configured base URL
   */
  getBaseUrl: (): string => {
    const baseUrl = process.env.REACT_APP_PUBLIC_API_URL || ''
    return `${baseUrl}${WEEZTIX_BASE_PATH}`
  },
}
